<template>
	<div id="report">
		<div class="block">
			<span class="demonstration">日期查询：</span>
			<el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
			<div style="display: inline-block;margin-left: 15px">
				<span class="title">员工姓名：</span>
				<el-input style="max-width:180px" size="small" v-model="workerName" placeholder="员工姓名"></el-input>
			</div>
			<el-button type="primary" icon="el-icon-search" size="mini" @click="clickSearch" style="margin-left:40px">查询</el-button>
			<el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
			<el-radio-group v-model="chartType" @change="changeChartType" class="y_pos">
				<el-radio label="workerBar">工资</el-radio>
				<el-radio label="workerBas">加工件数</el-radio>
			</el-radio-group>
		</div>
		<div v-if="flag == 0">
			<div id="workerBarDiv" ref="workerBarDiv" :style="{'width':'100%','marginTop':'20px','height':H}" style="position: relative"></div>
		</div>

		<div v-else style="width:100%;height:400px;margin-top:20px;text-align:center">
			<span style="line-height: 400px;">暂无数据</span>
		</div>
	</div>
</template>


<script>
  export default {
    name: "SalaryReport",
    data() {
      return {
        timeDefaultShow: [],
        workerBar: null,
        // workerBas:null,
        workerCircle: null,
        radio: 3,
        flag: 0,
        // money:'',
        workerData: null,

        ProcessingData: null,
        dateRange: [
          new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)), new Date()
        ],
        workerName: '',
        chartType: 'workerBar',
        showForm: false,

        H: '400px',
      };
    },
    mounted: function () {
      let W = document.documentElement.clientWidth || document.body.clientWidth;
      if (W > 1440) {
        this.H = '700px'
      } else if (W > 1366 && W <= 1440) {
        this.H = '500px'
      }
      this.steDefaultData();
      this.init();
      this.showReport('workerBar');
    },
    methods: {
      init() {
        this.clickSearch()
      },
      steDefaultData() {
        let time = commonUtils.timestampToDate(new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)), true).trim();
        this.timeDefaultShow = [time, time];
        console.log(this.timeDefaultShow)
      },
      clickSearch: function () {
        log(this.chartType)
        var dateRange = this.dateRange;
        if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
          this.$message.warning("请选择完整的时间区间");
          return
        }
        this.$RequestUtil.get({
          url: "/api/report/listWorkerProcessCount",
          params: {
            beginDate: dateRange[0],
            endDate: dateRange[1],
            workerName: this.workerName
          },
          success: res => {
            if (res.code == 0) {
              let XData = []//柱形图X轴的数据
              let YData = []//柱形图Y轴的数据
              let name = []//在柱形图上移入显示的数据字段
              let Label = []//在x轴上加上（￥）单位
              let individual = []//在x轴上加上（个）单位
              // res.data.salaryList.map(item=>item.workerName)
              if (this.chartType == 'workerBar') {
                // 柱状图按钮状态判断切换数据
                XData = res.data.salaryList.map(item => item.salary)
                YData = res.data.salaryList.map(item => item.workerName)
                name = "合计工资(￥)"
                Label = '￥'
              } else {
                XData = res.data.numberList.map(item => item.qualifiedProcessCount)
                YData = res.data.numberList.map(item => item.workerName)
                name = "合计加工件数(个)"
                individual = '个'
              }
              // log(XData,YData)
              this.showReport(XData, YData, name, Label, individual);
            }

          }
        });
      },
      //以上是工资数据表图
      changeChartType(val) {
        this.clickSearch()

      },
      clearSearch() {
		this.workerName = ''
		this.dateRange = [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)), new Date()]
      },
      showReport: function (XData, YData, name, Label, individual) {
        log(XData, YData)
        setTimeout(() => {
          if (this.workerBar == null) {
            this.workerBar = this.$Echarts.init(this.$refs["workerBarDiv"]);
          }

          var option = {
            title: {
              text: "员工绩效统计分析"
            },
            color: ["#3398DB", "#536941"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "none" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "value",
                logBase: 5,
                boundaryGap: false,
                name: '',
                axisTick: {
                  show: false
                },
                axisLabel: {
                  formatter: Label + ' {value}' + individual,
                  interval: 0,
                },
                inverse: false,
                //在x轴上数据显示加上单位
              }
            ],
            yAxis: [
              {
                type: "category",
                data: YData,
                axisTick: {
                  alignWithLabel: true,
                },


                axisLabel: {
                  formatter:(value) => {
                    if(value >= 10000){
                      value = (value / 10000) + 'W';
                    }
                    if(value >= 1000){
                      value = (value / 1000) + 'K';
                    }
                    return value;
                  },
                  interval: 0,
                },
                inverse: true
              }
            ],
            dataZoom: {
              type: 'inside',
              startValue: 0,
              endValue: 6,
              yAxisIndex: [0],
              filterMode: 'empty',
              zoomOnMouseWheel: false,
              moveOnMouseWheel: true
            },
            series: [
              {
                name: name,
                type: "bar",
                label: {
                  show: true,
                  position: 'right',
                  color: "#000",
                  formatter: Label +  '{c}' + individual
                },
                barMaxWidth: 50,
                // barMinHeight : 20,
                data: XData,
              },

            ],
          };

            this.workerBar.setOption(option);


        }, 0)

      },

    }
  };
</script>
<style scoped>
  @media screen and (max-width: 1366px) {
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 180px !important;
    }
  }

  .y_pos {
    position: absolute;
    left: 230px;
    top: 80px;
    z-index: 999;
  }

</style>



// WEBPACK FOOTER //
// src/views/report/SalaryReport.vue